var productQuantity = document.getElementsByClassName("pack__minQty");
var minProductQuantity = [];
for (let i = 0; i < productQuantity.length; i++) {
  document.getElementById("quantity-" + i).innerText =
    productQuantity[i].innerText;
  minProductQuantity[i] = parseInt(productQuantity[i].innerText);
}

function incrementProductQuantity(productId, price) {
  let qty =
    parseInt(document.getElementById("minQty-" + productId).innerText) + 1;
  let priceElement = document.getElementsByClassName("final-price");
  let packPrice = parseFloat(
    priceElement[0].innerText.substring(4).split(",").join("")
  );
  let newPrice = packPrice + price * 0.01;
  for (let element of priceElement) {
    element.innerText = newPrice.toLocaleString("en-US", {
      style: "currency",
      currency: "AED",
    });
  }
  document.getElementById("minQty-" + productId).innerText = qty;
  document.getElementById("quantity-" + productId).innerText = qty;
  document
    .getElementById("product-" + productId)
    .setAttribute("data-selectedQuantity", qty);
}

function decrementProductQuantity(productId, price) {
  let qty =
    parseInt(document.getElementById("minQty-" + productId).innerText) - 1;
  let priceElement = document.getElementsByClassName("final-price");
  let packPrice = parseFloat(
    priceElement[0].innerText.substring(4).split(",").join("")
  );
  let newPrice = packPrice - price * 0.01;
  if (qty >= 0) {
    for (let element of priceElement) {
      element.innerText = newPrice.toLocaleString("en-US", {
        style: "currency",
        currency: "AED",
      });
    }
    document.getElementById("minQty-" + productId).innerText = qty;
    document.getElementById("quantity-" + productId).innerText = qty;
    document
      .getElementById("product-" + productId)
      .setAttribute("data-selectedQuantity", qty);
  }
}
